import * as ng from 'angular';

export class HScrollController {
   static $inject = ['$scope', '$element', '$attrs'];

   constructor(private $scope:ng.IScope, private $element:ng.IAugmentedJQuery, $attrs) {
      $scope[$attrs['hscroll']] = this;
   }

   // Scroll to the left by one full width of the viewable area
   left() {
      // Use Math.max to ensure scrollLeft is never negative
      let scrollLeft = Math.max(0, this.position - this.$element[0].offsetWidth);
      // explicit digest cycle required after animation is complete
      // so sibling directives can get correct values for canGoLeft/Right
      this.$element.animate({scrollLeft: scrollLeft}, 250, () => this.$scope.$digest());
   }

   // Scroll to the right by one full width of the viewable area
   right() {
      // Use Math.min to ensure scrollLeft is never more than maxScroll
      let scrollLeft = Math.min(this.maxScroll, this.position + this.$element[0].offsetWidth);
      this.$element.animate({scrollLeft: scrollLeft}, 250, () => this.$scope.$digest());
   }

   get canGoLeft() {
      return this.position > 0;
   }

   get canGoRight() {
      return this.maxScroll - this.position > 0;
   }

   get position() {
      return this.$element[0].scrollLeft;
   }

   get maxScroll() {
      return this.$element[0].scrollWidth - this.$element[0].offsetWidth;
   }
}

ng.module('e360').directive('hscroll', function() {
   return {
      controller:HScrollController
   };
});
